import React, { FC } from 'react';
import { Box } from '@mui/material';
import Recommender from '../components/Recommender/form';

const RecommenderScreen: FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <Recommender />
        </Box>
      </Box>
    </Box>
  );
};

export default RecommenderScreen;
